import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, isDevMode, provideZoneChangeDetection } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideRouter, withViewTransitions } from '@angular/router';
import { provideEffects } from '@ngrx/effects';
import { provideState, provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideTranslateService } from '@ngx-translate/core';

import { environment } from '../environments/environment';
import { provideTranslation } from './app.i18n';
import { appRoutes } from './app.routes';

import { provideToastr, ToastrModule } from 'ngx-toastr';
import { ApiModule, Configuration } from './_generated';
import { AuthEffect, authFeature, authInterceptor } from './auth';
import { FlowbiteService } from './data-entry/services/flowbite.service';
import { DataEntryEffect } from './store/effects/data-type.effect';
import { EmissionPointsEffect } from './store/effects/emission-points.effect';
import { EntryCycleIdEffect } from './store/effects/entry-cycle-id.effect';
import { EntryCyclesEffect } from './store/effects/entry-cycles.effect';
import { ErrorEffects } from './store/effects/error.effects';
import { InitEffect } from './store/effects/init.effect';
import { ParameterEntryCyclesEffect } from './store/effects/parameter-entry-cycles.effect';
import { RequestStatusEffects } from './store/effects/request-status.effects';
import { ShopsEffect } from './store/effects/shops.effect';
import { SitesEffect } from './store/effects/sites.effect';
import { ToolsEffect } from './store/effects/tools.effect';
import { dataEntryReducers } from './store/reducers/data-entry.reducer';

export const appConfig: ApplicationConfig = {
  providers: [
    FlowbiteService,
    provideToastr(),
    provideEffects([
      AuthEffect,
      InitEffect,
      DataEntryEffect,
      SitesEffect,
      ShopsEffect,
      ToolsEffect,
      EntryCyclesEffect,
      EmissionPointsEffect,
      EntryCycleIdEffect,
      ParameterEntryCyclesEffect,
      ErrorEffects,
      RequestStatusEffects,
    ]),
    provideStore({
      dataEntry: dataEntryReducers,
    }),
    provideState(authFeature),
    provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes, withViewTransitions()),
    provideHttpClient(withInterceptors([authInterceptor])),
    importProvidersFrom([
      ToastrModule.forRoot({
        enableHtml: true,
        preventDuplicates: true,
      }),
    ]),
    provideTranslateService(provideTranslation()),
    importProvidersFrom([BrowserAnimationsModule]),
    importProvidersFrom([
      ApiModule.forRoot(
        () =>
          new Configuration({
            basePath: environment.appApiUrl,
            withCredentials: true,
          }),
      ),
    ]),
  ],
};
